import { useState } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import { Receipt, Lock } from '@mui/icons-material';
import POSHeader from '../../components/pos/POSHeader';
import POSTransactions from '../../components/pos/POSTransactions';
import POSClosures from '../../components/pos/POSClosures';
import NewExpenseDialog from '../../components/pos/NewExpenseDialog';
import NewSaleDialog from '../../components/pos/NewSaleDialog';
import { mockTransactions } from '../../components/pos/posData';

const POSPage = () => {
  const [tabValue, setTabValue] = useState(0);
  const [transactions, setTransactions] = useState(mockTransactions);
  
  // Estado de los diálogos
  const [expenseDialogOpen, setExpenseDialogOpen] = useState(false);
  const [saleDialogOpen, setSaleDialogOpen] = useState(false);
  const [saleType, setSaleType] = useState('libre'); // 'libre' o 'productos'

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Manejar apertura del diálogo de gasto
  const handleOpenExpenseDialog = () => {
    setExpenseDialogOpen(true);
  };

  // Manejar apertura del diálogo de venta
  const handleOpenSaleDialog = (type = 'libre') => {
    setSaleType(type);
    setSaleDialogOpen(true);
  };

  // Guardar nuevo gasto
  const handleSaveExpense = (expenseData) => {
    setTransactions([expenseData, ...transactions]);
  };

  // Guardar nueva venta
  const handleSaveSale = (saleData) => {
    setTransactions([saleData, ...transactions]);
  };

  return (
    <Box sx={{ width: '100%' }}>
      {/* Header superior con controles de caja */}
      <POSHeader 
        onNewExpense={handleOpenExpenseDialog}
        onNewSale={handleOpenSaleDialog}
      />

      {/* Tabs de navegación */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            '& .MuiTab-root': {
              minHeight: 56,
              textTransform: 'none',
            },
          }}
        >
          <Tab
            icon={<Receipt />}
            iconPosition="start"
            label="Transacciones"
            sx={{ fontWeight: tabValue === 0 ? 'bold' : 'normal' }}
          />
          <Tab
            icon={<Lock />}
            iconPosition="start"
            label="Cierres de Turno"
            sx={{ fontWeight: tabValue === 1 ? 'bold' : 'normal' }}
          />
        </Tabs>
      </Box>

      {/* Contenido según la pestaña seleccionada */}
      <Box role="tabpanel" hidden={tabValue !== 0}>
        {tabValue === 0 && <POSTransactions transactions={transactions} />}
      </Box>

      <Box role="tabpanel" hidden={tabValue !== 1}>
        {tabValue === 1 && <POSClosures />}
      </Box>

      {/* Diálogos */}
      <NewExpenseDialog
        open={expenseDialogOpen}
        onClose={() => setExpenseDialogOpen(false)}
        onSave={handleSaveExpense}
      />
      
      <NewSaleDialog
        open={saleDialogOpen}
        onClose={() => setSaleDialogOpen(false)}
        onSave={handleSaveSale}
        tipoVenta={saleType}
      />
    </Box>
  );
};

export default POSPage;
